export default "__VITE_ASSET__BefalefZ__"